import React, { forwardRef } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

const CustomInput = forwardRef((props, ref) => (
    <input ref={ref} {...props} className="border-none" />
));

CustomInput.displayName = 'CustomInput';

const PhoneNumberField = ({
    input,
    placeholder,
    meta: { touched, error },
    'data-cy': dataCy,
}) => (
    <>
        <PhoneInput
            {...input}
            onFocus={() => {
                input.onFocus();
            }}
            onBlur={() => {
                input.onBlur();
            }}
            className="phone-input"
            defaultCountry="TH"
            international
            placeholder={placeholder}
            onChange={(value) => input.onChange(value)}
            inputComponent={CustomInput}
            data-cy={dataCy}
        />
        {touched && error && (
            <span
                className="form__form-group-error text-justify"
                data-cy={`${dataCy}--error`}
            >
                {error}
            </span>
        )}
    </>
);

PhoneNumberField.defaultProps = {
    placeholder: '',
    meta: {
        touched: false,
        error: '',
    },
    'data-cy': undefined,
};

export default PhoneNumberField;
